var map = {
	"./br/PT/S1/fj2.png": 35541,
	"./fj2.png": 81519,
	"./in/EN/S1/fj2.png": 79144,
	"./ph/EN/S1/fj2.png": 88861,
	"./ph/EN/S2/fj2.png": 46176,
	"./vn/VI/S1/fj2.png": 57901
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68493;